<template>
  <div class="box" :class="{ 'mobile-rotate': isMobile }">
    <!-- <div class="aaa"></div> -->
    <div v-if="signature" class="title_name" :class="{ 'title-en': isEnglish }">
      {{ $t('signature.signArea') }}
    </div>

    <div class="footer" v-if="signature">
      <!-- <div><button @click="canvasClear" class="button">清除</button></div> -->
      <!-- <div class="d-flex"><button @click="saveAsImg" class="button">提交（签署法人中文拼音名字）</button></div> -->
      <!-- <div><button @click="saveAsImg"  type="button" class="btn btn-primary">提交（签署法人中文拼音名字）</button></div> -->
      <div><button @click="canvasClear" class="btn btn-secondary action-btn" :disabled="sub_disabled">{{ $t('signature.clear') }}</button></div>
      <div>
        <button @click="saveAsImg" type="button" :disabled="sub_disabled" class="btn btn-light action-btn submit-btn">{{ $t('signature.submit') }}</button>
      </div>
    </div>

    <div v-if="signature">
      <sign-canvas class="canvas" ref="SignCanvas" :options="options" v-model="value" />
    </div>

    <!-- 成功 -->
    <div v-if="sucess" class="result">
      <img src="../stactic/image/sucess.png" alt="" />
      <div class="res">{{ $t('signature.success') }}</div>
    </div>
    <!-- <b-modal id="Confirm"></b-modal> -->
    <Confirm ref="Confirm" :rotate="isMobile"></Confirm>
    <Hint ref="Hint" :rotate="isMobile"></Hint>
  </div>
</template>

<script>
import SignCanvas from "sign-canvas"
import basetoFile from "../stactic/js/basetoFile"
import rotateBase64Img from "../stactic/js/edg"
// 确认框
import Confirm from "../components/Confirm.vue"
import Hint from "../components/Hint.vue"
export default {
  name: "dev",
  components: { SignCanvas, Confirm, Hint },
  data() {
    return {
      snackbar: false,
      snackbarText: null,
      value: null,
      options: {},
      // 订单 编号
      order_no: "",
      // 定单的 文件lsit  json
      file_list: "",
      // 电子签名地址
      signature_path: "",
      signature: true,
      sucess: false,
      // error:false,
      // error_content:''
      // 初始画布 size
      initCanvasSize: "",
      sub_disabled: false,
      isMobile: false,
      bodyOverflow: "",
      htmlOverflow: "",
    }
  },
  computed: {
    isEnglish() {
      return this.$i18n.locale === 'en-US'
    },
  },
  watch: {},

  async mounted() {
    this.isMobile = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)
    this.bodyOverflow = document.body.style.overflow
    this.htmlOverflow = document.documentElement.style.overflow
    document.body.style.overflow = "hidden"
    document.documentElement.style.overflow = "hidden"
    // 获取 order_no json file_list
    this.order_no = this.$route.query.order_no
    this.file_list = this.$route.query.file_list
    // 设置画布
    await this.setCanvas()
    // 通过初始化的图片大小判断 是否签字
    this.initCanvasSize = basetoFile(this.$refs.SignCanvas.saveAsImg(), "file").size
    console.log('初始大小：',this.initCanvasSize);
  },
  beforeDestroy() {
    document.body.style.overflow = this.bodyOverflow
    document.documentElement.style.overflow = this.htmlOverflow
  },
  methods: {
    setCanvas() {
      //  设置画布
      const viewportWidth = document.documentElement.clientWidth
      const viewportHeight = document.documentElement.clientHeight
      const footerHeight = this.isMobile ? 0 : 86
      const options = {
        isDpr: false, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: "bevel", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: viewportWidth, //canvas宽高 [Number] 可选
        canvasHeight: Math.max(viewportHeight - footerHeight, 300), //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        // bgColor: "#fcc", //背景色 [String] 可选 
        bgColor: "transparent", //背景色 [String] 可选 transparent
        borderWidth: -1, // 网格线宽度  [Number] 可选
        borderColor: "#ff787f", //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      }
      this.options = options
    },
    canvasClear() {
      this.$refs.SignCanvas.canvasClear()
    },

    //提交
    async saveAsImg() {
      console.log('目前大小',basetoFile(this.$refs.SignCanvas.saveAsImg(), "file").size);
      // 判断是否签了字
      const s = basetoFile(this.$refs.SignCanvas.saveAsImg(), "file").size
      if (this.initCanvasSize == s) {
        this.$refs.Hint.confirm({
          title: this.$t('signature.hintTitle'),
          text: this.$t('signature.hintText'),
          ok_text: this.$t('signature.hintOk'),
        })
        return
      }
      this.sub_disabled = true
      this.$refs.Confirm.confirm({
        title: this.$t('signature.confirmTitle'),
        text: this.$t('signature.confirmText'),
        close_text: this.$t('signature.confirmClose'),
        ok_text: this.$t('signature.confirmOk'),
      })
        .then(async () => {
          const rawImg = this.$refs.SignCanvas.saveAsImg()
          const img = await this.normalizeDesktopSignImage(rawImg)
          const file = basetoFile(img, "file")
          // 开始上传签名图片
          let formdata = new FormData()
          formdata.append("file", file)
          const res = await this.$axios.post("/commonUploadFiles", formdata)
          if (res.data.code == 200) {
            // 电子签名地址
            this.signature_path = res.data.data[0]
            // 提交电子签名
            const r = await this.$axios.post("/signature/addSignature", {
              order_no: this.order_no,
              signature_path: this.signature_path,
              file_list: this.file_list,
            })
            if (r.data.code == 200) {
              // 直接展示成功
              this.signature = false
              this.sucess = true
            } else {
              alert(r.data.msg)
              this.sub_disabled = false
            }
          } else {
            alert(res.data.msg)
            this.sub_disabled = false
          }
        })
        .catch((e) => {
          this.sub_disabled = false
        })
    },
    normalizeDesktopSignImage(base64) {
      if (this.isMobile) {
        return Promise.resolve(base64)
      }

      return new Promise((resolve) => {
        // 桌面端导出在当前库版本下会固定出现方向偏转，提交前统一回正。
        rotateBase64Img(base64, 90, (rotated) => {
          resolve(rotated || base64)
        })
      })
    },

    /**
     * 下载图片
     */
    // downloadSignImg() {
    //   this.$refs.SignCanvas.downloadSignImg();
    // }
  },
}
</script>

<style scoped>
.box {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  overflow: hidden;
}
.title_name{
  color: rgba(0, 0, 0, 0.9);
  font-size: 18px;
  position: absolute;
  top: 16px;
  left: 16px;
  right: auto;
  padding: 0;
  z-index: 10;
}

.title_name.title-en {
  top: 42px;
}

.mobile-rotate .title_name {
  top: 140px;
  left: auto;
  right: 0px;
  padding: 32px;
  transform: rotate(90deg);
  transform-origin: right top;
}

.mobile-rotate .title_name.title-en {
  top: 174px;
  right: 84px;
}

.footer {
  width: 100%;
  min-height: 86px;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  top: auto;
  background: rgba(108, 117, 125, 0.95);
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  align-items: center;
  padding: 12px 16px;
  z-index: 15;
}
.footer > div {
  transform: none;
}

.action-btn {
  width: 200px;
  height: 46px;
}

.submit-btn {
  width: auto;
  min-width: 280px;
}

.mobile-rotate .footer > div {
  transform: rotate(90deg);
}

.mobile-rotate .footer {
  width: 100px;
  height: 100%;
  min-height: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: auto;
  background: gray;
  flex-direction: column;
  justify-content: space-around;
  gap: 0;
  padding: 0;
}

.mobile-rotate .action-btn {
  width: 250px;
  height: 50px;
}

.mobile-rotate .submit-btn {
  min-width: 250px;
}

.button {
  width: 300px;
  height: 50px;
}

.result {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
